export const CAPS_DEFAULT_ICON_MAP = {
  skills: 'scroll-text',
  sources: 'database-02'
}

export const CAPS_MAP = {
  skills: {
    '/discover': {
      icon: 'telescope',
    },
    '/enrich': {
      icon: 'wand-sparkles',
      description: 'Build a complete profile including contact details for a named person.',
    },
    '/add-companies': {
      icon: 'building-02',
    },
    '/snapshot': {
      icon: 'file-box',
      description: 'Generate a comprehensive company or person overview.',
    },
    '/qualify': {
      icon: 'hash',
    },
    '/message': {
      icon: 'message-square-text',
    },
    '/prioritize': {
      icon: 'medal',
    },
    '/timeline': {
      icon: 'hourglass',
    },
    '/org-map': {
      icon: 'dataflow-04',
      description: 'Discover leadership and build an organizational hierarchy.',
    },
    '/relationship': {
      title: 'Relationship',
      icon: 'handshake',
    },
    '/competitors': {
      title: 'Competitors',
      icon: 'flag-01',
    },
    '/earnings': {
      title: 'Earnings',
      icon: 'file-07',
    },
    '/lookalikes': {
      title: 'Lookalikes',
      icon: 'copy-07',
    },
    '/firmographics': {
      title: 'Firmographics',
      icon: 'filter-funnel-01',
    },
    '/find-buyer': {
      title: 'Find buyers',
      icon: 'target-04',
    },
    '/meet': {
      title: 'Meet',
      icon: 'briefcase-01'
    },
    '/outreach': {
      title: 'Outreach',
      icon: 'message-square-text',
    },
    '/prep': {
      icon: 'book-open-check',
    }
  },
  sources: {
    '@web': {
      icon: 'globe',
    },
    '@files': {
      icon: 'hard-drive',
    },
    '@apollo': {
      icon: 'sources/apollo',
    },
    '@salespoint': {
      icon: 'sources/sales-point',
    },
    '@globaldata': {
      icon: 'sources/global-data',
    },
    '@tbr': {
      icon: 'sources/tbr',
    },
    '@analysys-mason': {
      icon: 'sources/analysys-mason',
    },
    '@omdia': {
      icon: 'sources/omdia',
    },
    '@appledore': {
      icon: 'sources/appledore',
    }
  }
}

export const ALL_CAPS_MAP = {
  ...CAPS_MAP.skills,
  ...CAPS_MAP.sources
}

export function normalizeSkills(skills) {
  return (skills || []).map(skill => {
    const defaults = CAPS_MAP.skills[skill.command]
    return {
      ...defaults,
      ...skill,
      icon: skill.icon || defaults?.icon || CAPS_DEFAULT_ICON_MAP.skills
    }
  })
}

export function normalizeSources(sources) {
  return (sources || []).map(source => {
    const defaults = CAPS_MAP.sources[source.command]
    return {
      ...defaults,
      ...source,
      icon: source.icon || defaults?.icon || CAPS_DEFAULT_ICON_MAP.sources
    }
  })
}
